module.exports = "<div class=\"father-events-row-details\">\n  <div *ngIf=\"childEvents else loading\">\n    <parent-events-row-details-child-events-row *ngFor=\"let child of childEvents\"\n                      [childEvent]=\"child\"></parent-events-row-details-child-events-row>\n  </div>\n  <ng-template #loading>\n    Loading...\n  </ng-template>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/events-screen/parent-events-row-details/parent-events-row-details.component.html
// module id = ./src/app/admin/events-screen/parent-events-row-details/parent-events-row-details.component.html
// module chunks = main